export default __webpack_public_path__ + "static/media/November2014.7fc7cf18.png";